// ABOUTME: Renders the SVG for the requested loading animation type
// ABOUTME: Exhaustive over LoadingAnimationType so a new type fails to compile until it is drawn
import * as React from 'react';
import Bubbles from './Bubbles';
import Spin from './Spin';
import { LoadingAnimationType } from './Types';

const Animation: React.FC<{ type: LoadingAnimationType }> = ({ type }) => {
  switch (type) {
    case 'bubbles':
      return <Bubbles />;
    case 'spin':
      return <Spin />;
  }
};

export default Animation;
